<template>
  <div >
    <!-- {{editMode}} -->
    <ValidationObserver v-slot="{ handleSubmit }">
      
      <!-- <CForm @submit.prevent="handleSubmit(onSave)"> -->
        <CCard>
          <CCardHeader>
            <CRow class="py-2 d-flex ai-center">
              <div v-if="title" class="px-3">
                <strong>{{ title }}</strong>
              </div>
              <div v-if="canEdit">
                <CCol v-if="!editMode" class="ai-center d-flex">
                  <CCol
                    @click.stop="toggleEdit()"
                   
                  >

                    <span>
                      {{$t('hotelInfo.edit')}}
                    </span>
                    <CIcon color="white" name="cil-pencil" />
                  </CCol>
                </CCol>

                <CCol v-else class="ai-center d-flex">
                  <CRow v-if="needCancel">
                    <CCol
                      @click="onCancel()"
                 
                    >

                     <span>
                      {{$t('hotelInfo.cancel')}}
                    </span>
                      <CIcon color="failure" name="cilXCircle" />
                    </CCol>

                    <button
                      type="submit" @click.prevent="handleSubmit(onSave)"
                 
                    >
                    <span>
                      {{$t('hotelInfo.save')}}
                    </span>
                      <CIcon color="red" name="cilCheck" />
                    </button>
                  </CRow>
                  <div class="deletePos" v-if="toDelete">
                    <button
                    
                      @click="deleteCard"
                    >
                     Delete
                    </button>
                  </div>
                </CCol>
              </div>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <slot></slot>
          </CCardBody>
        </CCard>
      <!-- </CForm> -->
    </ValidationObserver>
    <cAlertModal
      v-if="showAlertModal"
      :key="'sys'"
      :buttonList="getModalButtons()"
      :status="2"
      :isShowIcon="true"
      :show="showAlertModal"
      :desc="$t('hotelInfo.desc')"
    >
    </cAlertModal>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { COMPONENT_NAME, PATHNAME } from "../../../../util/constants";
import Logger from "../../../../services/logger";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
import cAlertModal from "../../../../components/form/cAlertModal";

export default {
  name: COMPONENT_NAME.C_CONTENT_EDIT,
  components: {
    ValidationObserver,
    cAlertModal,
  },

  props: {
    title: {
      type: String,
      default: null,
    },

    toDelete: {
      type: Boolean,
      default: false,
    },

    editMode: {
      type: Boolean,
      default: false,
    },

    canEdit: {
      type: Boolean,
      default: true,
    },

    alertOnCancel: {
      type: Boolean,
      default: true,
    },

    needCancel: {
      type: Boolean,
      default: true,
    },
  },

  data: () => {
    return {
      isEditMode: false,
      showAlertModal: false,
    };
  },
      watch: {
       isEditMode:{
        immediate: true, 
        deep: true,
    handler: function (newVal, oldVal) {
    //  if(this.isEditMode==true){
       this.$root.$emit('isInEditMode',this.isEditMode,this.title);
    //  }
      }
      },
        editMode:{
        immediate: true, 
        deep: true,
    handler: function (newVal, oldVal) {
      this.editMode=newVal;
     
      }
      },
  },
  methods: {

    assignEditVal(pEditMode){
 this.isEditMode = pEditMode
},
    resetFormData() {
      try {
        if (BaseConfiguration.isDebug) console.log("resetFormData");

        this.$emit("onCancel");
        this.toggleEdit();
      //  this.toggleAlertModal();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_CONTENT_EDIT,
          "error in resetFormData",
          err.toString(),
          "resetFormData",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getModalButtons() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getModalButtons");
        retValue = [
          {
            name: this.$t("hotelInfo.leave"),
            func: this.resetFormData,
          },

          {
            name: this.$t("hotelInfo.stay"),
            func: this.toggleAlertModal,
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_CONTENT_EDIT,
          "error in getModalButtons",
          err.toString(),
          "getModalButtons",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleAlertModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleAlertModal");

        this.showAlertModal = !this.showAlertModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_CONTENT_EDIT,
          "error in toggleAlertModal",
          err.toString(),
          "toggleAlertModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    deleteCard(){
      this.$emit('toDeleteCard');
    },

 async   onSave() {
      try {
        if (BaseConfiguration.isDebug) console.log("onSave");
        this.$root.$emit('isInEditMode',false,this.title);
        await this.$emit("onSave");


   
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_CONTENT_EDIT,
          "error in onSave",
          err.toString(),
          "onSave",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onCancel() {
      try {
        if (BaseConfiguration.isDebug) console.log("onCancel");

        this.resetFormData()

        //this.$emit("onCancel");
       // this.toggleAlertModal();
        // this.toggleEdit();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_CONTENT_EDIT,
          "error in onCancel",
          err.toString(),
          "onCancel",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    toggleEdit() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleEdit");

        this.isEditMode = !this.isEditMode;

        this.$emit("onToggleEdit");
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.C_CONTENT_EDIT,
          "error in toggleEdit",
          err.toString(),
          "toggleEdit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },

  created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      this.isEditMode = this.editMode;
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.C_CONTENT_EDIT,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
};
</script>

<style>
.funcrow{
  width:1400px;
}
.deletePos{
  margin-left: 10px;
  padding-left: 10px;
}
</style>
